import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

const KEY = "tpv_device";
export const getDevice = () => ({ autoPrint: false, drawerOnCash: true, touch: "auto", ...JSON.parse(localStorage.getItem(KEY) || "{}") });
export const setDevice = (d) => { localStorage.setItem(KEY, JSON.stringify(d)); window.dispatchEvent(new Event("tpv:device")); };
export const touchActive = () => { const m = getDevice().touch; return m === "on" || (m === "auto" && window.matchMedia("(pointer: coarse)").matches); };

const HELD = "tpv_held";
export const payKey = (p) => ({ credit: "pay_credit", card: "pay_card", split: "pay_split", house: "pay_house", advance: "pay_advance", transfer: "pay_transfer", proforma: "tm_proforma" }[p] || "pay_cash");
export const getHeld = () => JSON.parse(localStorage.getItem(HELD) || "[]");
export const saveHeld = (list) => localStorage.setItem(HELD, JSON.stringify(list));

export const openDrawer = () => window.dispatchEvent(new CustomEvent("tpv:drawer", { detail: { manual: false } }));
export const openDrawerManual = () => window.dispatchEvent(new CustomEvent("tpv:drawer", { detail: { manual: true } }));
export const openShiftDialog = (tab = "x") => window.dispatchEvent(new CustomEvent("tpv:shift", { detail: { tab: typeof tab === "string" ? tab : "x" } }));

let channel = null;
const chan = () => { if (!channel && "BroadcastChannel" in window) channel = new BroadcastChannel("dukkan-display"); return channel; };
let pushTimer = null;
let pushCode = null;
const pushRemote = (msg) => {
  if (localStorage.getItem("sp_remote_display") === "0") return;
  clearTimeout(pushTimer);
  pushTimer = setTimeout(() => api.post("/display/push", { device_id: localStorage.getItem("sp_device"), state: { ...msg, at: Date.now() } }).then((r) => { pushCode = r.data?.code || pushCode; }).catch(() => {}), 40);
};
export const getPushCode = () => pushCode;
export const postDisplay = (msg) => { chan()?.postMessage(msg); pushRemote(msg); };
export const remoteDisplayUrl = (code) => `${window.location.origin}/display?code=${code}`;
export const onDisplay = (fn) => { const c = chan(); if (!c) return () => {}; const h = (e) => fn(e.data); c.addEventListener("message", h); return () => c.removeEventListener("message", h); };
export const openCustomerDisplay = () => { displayWin = window.open("/display", "dukkan-display", "popup,width=1024,height=700"); return displayWin; };
let displayWin = null;
export const closeCustomerDisplay = () => {
  const w = displayWin && !displayWin.closed ? displayWin : null;
  if (!w) return false;
  w.close(); displayWin = null; return true;
};
const openLayers = () => document.querySelectorAll('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [role="menu"][data-state="open"], [data-radix-popper-content-wrapper]').length;
// F4: close the customer display popup and every open dialog/sheet/menu, without leaving the app.
export const closeAllWindows = () => {
  let closed = closeCustomerDisplay();
  const esc = () => document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", code: "Escape", keyCode: 27, bubbles: true }));
  if (openLayers()) {
    closed = true;
    let n = 0;
    const tick = () => { if (openLayers() && n++ < 8) { esc(); setTimeout(tick, 60); } };
    tick();
  }
  window.dispatchEvent(new CustomEvent("orbit:close-all"));
  return closed;
};

export const SHORTCUTS = [
  ["F1", "sc_help"], ["F2", "sc_search"], ["F3", "sc_close"], ["F11", "sc_scan"], ["F4", "sc_f4"], ["F8", "pay_credit"],
  ["F6", "shift"], ["F7", "lock"], ["F9", "open_drawer"], ["F10", "customer_display"], ["F12", "price_check"],
  ["Alt+1…9", "sc_modules"], ["Del", "sc_delete_line"], ["F5", "hold"], ["Shift+F5", "recall"],
];

// Keys like "F4", "Alt+1"; F-keys also fire while typing in inputs.
export function useHotkeys(map, enabled = true) {
  const ref = useRef(map);
  ref.current = map;
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (e) => {
      const k = `${e.altKey ? "Alt+" : ""}${e.shiftKey && /^F\d+$/.test(e.key) ? "Shift+" : ""}${e.key.length === 1 ? e.key.toUpperCase() : e.key}`;
      const fn = ref.current[k] || (e.altKey && /^Digit\d$/.test(e.code) ? ref.current[`Alt+${e.code.slice(5)}`] : null);
      if (!fn) return;
      const typing = ["INPUT", "TEXTAREA"].includes(e.target?.tagName);
      if (typing && !/^F\d+$/.test(e.key) && !e.altKey) return;
      e.preventDefault();
      fn(e);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [enabled]);
}
